import React from 'react';

export const HeroVisual = ({ image }) => (
  <div className="hidden md:block relative">
    <div className="relative rounded-2xl overflow-hidden shadow-2xl">
      <img src={image} alt="Professional consultation" className="w-full h-[600px] object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-cyan-900/20 to-transparent"></div>
    </div>

    <div className="absolute -bottom-8 -left-8 bg-white p-6 rounded-xl shadow-xl">
      <div className="flex items-center gap-4">
        <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
          ₹
        </div>
        <div>
          <div className="text-2xl font-bold text-gray-900">₹100+ Cr</div>
          <div className="text-sm text-gray-600">Loans Processed</div>
        </div>
      </div>
    </div>
  </div>
);

export default HeroVisual;
